exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-content[data-v-197481ba]{font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333;line-height:1.6;padding:12px}.terms-content .tc-heading[data-v-197481ba]{margin-top:1rem;font-size:1rem;color:#292f4c;font-weight:600}.terms-content p[data-v-197481ba]{margin:.5rem 0;text-align:justify}.terms-content ul.tc-list[data-v-197481ba]{margin:.5rem 0 1rem 1.2rem;padding-left:.6rem}.terms-content ul.tc-list li[data-v-197481ba]{margin:.25rem 0}.dialog-footer[data-v-197481ba]{display:flex;justify-content:flex-end;gap:10px}", ""]);

// exports
